import type { C1_EloItemViewAnchor } from "../types/C1_EloTypes";
import type { WallSide } from "../types/C1_ModelTypes";

export const C1_TAG_RADIUS = 9.5;
export const C1_SYMBOL_TAG_HALF_HEIGHT = 14;
export const C1_TAG_BORDER_WIDTH = 1.5;

export const PLAN_VIEW_ANCHORS: Record<C1_EloItemViewAnchor, { x: number; y: number }> = {
  "top-left": { x: 0, y: 0 },
  "top-center": { x: 0.5, y: 0 },
  "top-right": { x: 1, y: 0 },
  "center-left": { x: 0, y: 0.5 },
  center: { x: 0.5, y: 0.5 },
  "center-right": { x: 1, y: 0.5 },
  "bottom-left": { x: 0, y: 1 },
  "bottom-center": { x: 0.5, y: 1 },
  "bottom-right": { x: 1, y: 1 },
};

const wallRotation: Record<WallSide, number> = { top: 0, right: 90, bottom: 180, left: 270 };

/** Offsets the upright tag from its mounting point; the outer size transform scales both together. */
export function tagPlacementOffset({ anchor, wallSide, wallMounted, rotation, reflected, withSymbol }: {
  anchor?: C1_EloItemViewAnchor;
  wallSide?: WallSide;
  wallMounted: boolean;
  rotation: number;
  reflected: boolean;
  withSymbol: boolean;
}): { x: number; y: number } {
  const point = PLAN_VIEW_ANCHORS[anchor ?? (wallMounted ? "top-center" : "center")];
  const halfWidth = C1_TAG_RADIUS + C1_TAG_BORDER_WIDTH / 2;
  const halfHeight = (withSymbol ? C1_SYMBOL_TAG_HALF_HEIGHT : C1_TAG_RADIUS) + C1_TAG_BORDER_WIDTH / 2;
  const x = (0.5 - point.x) * 2 * (reflected ? -1 : 1);
  const y = (0.5 - point.y) * 2;
  const radians = (wallSide ? wallRotation[wallSide] : rotation) * Math.PI / 180;
  return {
    x: (x * Math.cos(radians) - y * Math.sin(radians)) * halfWidth,
    y: (x * Math.sin(radians) + y * Math.cos(radians)) * halfHeight,
  };
}
